module.exports = __webpack_public_path__ + "img/pending_zone.4d95c121.svg";